export default __webpack_public_path__ + "static/media/badge-app-store.8c4986ee.svg";